import React, { useState } from 'react';
import { MessageSquare, Send, Trash2 } from 'lucide-react';
import { logError } from '@/lib/logger';

const formatNoteDate = (iso) =>
  iso ? new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';

export default function NotesSection({ notes, onAdd, onDelete }) {
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const list = notes || [];

  const submit = async () => {
    const value = text.trim();
    if (!value || sending) return;
    setSending(true);
    try {
      await onAdd(value);
      setText('');
    } catch (e) {
      logError('Add note failed:', e);
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="notes-section">
      <p className="text-[10px] uppercase tracking-wider text-earth/40 font-sans font-semibold mb-2 flex items-center gap-1"><MessageSquare size={10} /> Notes & Activity</p>
      <div className="space-y-2 mb-3 max-h-[200px] overflow-y-auto">
        {list.length === 0 ? (
          <p className="text-xs text-earth/30 font-sans italic py-2" data-testid="notes-empty">No notes yet. Add a note to track conversations.</p>
        ) : (
          [...list].reverse().map(note => (
            <div key={note.id} className="bg-cream/40 rounded-lg px-3 py-2 border border-earth/5 group" data-testid={`note-${note.id}`}>
              <div className="flex items-start justify-between">
                <p className="text-sm text-earth-dark font-sans">{note.text}</p>
                <button onClick={() => onDelete(note.id)} className="text-earth/20 hover:text-red-400 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0 ml-2" data-testid={`delete-note-${note.id}`}><Trash2 size={10} /></button>
              </div>
              <p className="text-[9px] text-earth/30 font-sans mt-1">{formatNoteDate(note.created_at)}</p>
            </div>
          ))
        )}
      </div>
      <div className="flex gap-2">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          placeholder="Add a note..."
          className="flex-1 border border-earth/15 rounded-md px-3 py-2 text-sm font-sans text-earth-dark focus:outline-none focus:ring-2 focus:ring-saffron/30 bg-cream/30"
          data-testid="note-input"
        />
        <button onClick={submit} disabled={!text.trim() || sending} className="bg-saffron text-white px-3 py-2 rounded-md hover:bg-saffron-dark transition-colors disabled:opacity-40" data-testid="add-note-btn">
          <Send size={14} />
        </button>
      </div>
    </div>
  );
}
